import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button } from "@/components/Buttons";
import CouponCodeForm from "@/components/Form/CouponCodeForm";
import { ErrorMessage } from "@/components/Form/Parts/index";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import Loading from "@/components/Loading";
import OnlyAndroid from "@/components/OnlyAndroid";
import { rightViewTerm } from "@/components/RightViewTerm";
import TargetBlankLink from "@/components/TargetBlankLink";
import { usePaymentInstrumentInfoQuery, usePurchaseEstimateQuery, usePurchaseEstimateWithCouponLazyQuery } from "@/hooks";
import config from "@/lib/config";
import { PAYMENT_METHOD_ID, PAYMENT_METHOD_NAMES } from "@/lib/constants";
import dayjs from "@/lib/day";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PurchaseFormStep2(_ref) {
  var _estimateWithCoupon$p;
  let {
    onSubmit,
    product,
    broadcastDiscount,
    paymentMethodId,
    paymentInstrumentId,
    error,
    onBack,
    setSubmitted
  } = _ref;
  const router = useRouter();
  const {
    0: unappliedCouponError,
    1: setUnppliedCouponError
  } = useState();
  const {
    0: applyVoucherCode,
    1: setApplyVoucherCode
  } = useState();

  // 視聴期間
  const [rightLabel, rightText] = rightViewTerm(product === null || product === void 0 ? void 0 : product.right);
  // 決済日
  const purchaseDate = dayjs().format("YYYY/MM/DD");
  // 販売期間
  const salesStartAt = product !== null && product !== void 0 && product.sales_start_at ? dayjs(product.sales_start_at).format("YYYY/MM/DD") : null;
  const salesEndAt = product !== null && product !== void 0 && product.sales_end_at ? dayjs(product.sales_end_at).format("YYYY/MM/DD") : null;

  // react-hook-form
  const {
    register,
    handleSubmit,
    formState,
    getValues,
    setValue,
    watch
  } = useForm({
    mode: "all"
  });
  const {
    isValid,
    isSubmitting
  } = formState;
  const watchCouponCode = watch("couponCode");

  // 支払い方法
  const {
    data,
    loading
  } = usePaymentInstrumentInfoQuery({
    variables: {
      id: paymentInstrumentId
    }
  });
  const paymentInstrument = (data === null || data === void 0 ? void 0 : data.paymentInstrumentInfo) || {};
  const paymentMethod = useMemo(() => {
    if (paymentInstrument) {
      return paymentInstrument.payment_method_id;
    }
  }, [paymentInstrument]);
  const paymentIconClassName = useMemo(() => {
    return paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD_3DS ? styles.paymentCreditCardImage : styles.paymentOtherImage;
  }, [paymentMethod]);
  const creditCardInfo = useMemo(() => {
    if (paymentInstrument) {
      var _paymentInstrument$va, _paymentInstrument$va2;
      return {
        type: paymentInstrument === null || paymentInstrument === void 0 || (_paymentInstrument$va = paymentInstrument.values) === null || _paymentInstrument$va === void 0 ? void 0 : _paymentInstrument$va.card_type,
        number: `****-****-****-${paymentInstrument === null || paymentInstrument === void 0 || (_paymentInstrument$va2 = paymentInstrument.values) === null || _paymentInstrument$va2 === void 0 ? void 0 : _paymentInstrument$va2.card_number}`
      };
    }
  }, [paymentInstrument]);

  // 購入可能か確認
  const {
    data: estimateData,
    loading: estimateLoading
  } = usePurchaseEstimateQuery({
    variables: {
      productId: Number(product.id),
      paymentMethodId
    },
    onCompleted: _ref2 => {
      let {
        estimate
      } = _ref2;
      // エラーの場合は前のページに戻す
      if (estimate !== null && estimate !== void 0 && estimate.error) {
        onBack(estimate.error);
      }
    }
  });
  const estimate = estimateData === null || estimateData === void 0 ? void 0 : estimateData.estimate;

  // クーポン
  const [estimateWithCouponQuery, {
    data: estimateWithCouponData,
    loading: couponLoading
  }] = usePurchaseEstimateWithCouponLazyQuery({
    variables: {
      productId: Number(product.id),
      paymentMethodId
    },
    onCompleted: _ref3 => {
      let {
        estimateWithCoupon
      } = _ref3;
      const voucherCode = (() => {
        if (!(estimateWithCoupon !== null && estimateWithCoupon !== void 0 && estimateWithCoupon.error)) {
          return getValues("couponCode");
        }
        return null;
      })();
      setApplyVoucherCode(voucherCode);
      setValue("couponCode", "", {
        shouldValidate: true
      });
    }
  });
  const estimateWithCoupon = estimateWithCouponData === null || estimateWithCouponData === void 0 ? void 0 : estimateWithCouponData.estimateWithCoupon;
  const applyVoucher = estimateWithCoupon === null || estimateWithCoupon === void 0 || (_estimateWithCoupon$p = estimateWithCoupon.product) === null || _estimateWithCoupon$p === void 0 || (_estimateWithCoupon$p = _estimateWithCoupon$p.voucherCode) === null || _estimateWithCoupon$p === void 0 ? void 0 : _estimateWithCoupon$p.voucher;
  // 割引価格
  const discountPrice = useMemo(() => {
    // サーバー側で放送契約割引とキャンペーンの割引額を比較しているので
    // バウチャーが適用されたということは放送契約割引より安いということになる
    if (applyVoucher) {
      var _estimateWithCoupon$p2;
      return {
        label: "適用後金額",
        value: estimateWithCoupon === null || estimateWithCoupon === void 0 || (_estimateWithCoupon$p2 = estimateWithCoupon.product) === null || _estimateWithCoupon$p2 === void 0 ? void 0 : _estimateWithCoupon$p2.discountPrice
      };
    }
    if (broadcastDiscount !== null && broadcastDiscount !== void 0 && broadcastDiscount.result) {
      var _product$right;
      return {
        label: "割引適用後金額",
        value: (product === null || product === void 0 || (_product$right = product.right) === null || _product$right === void 0 ? void 0 : _product$right.discount_price) || 0
      };
    }
    return null;
  }, [product, broadcastDiscount, applyVoucher, estimateWithCoupon]);

  // 割引の名前
  const discountName = useMemo(() => {
    if (applyVoucher) {
      return {
        label: "適用されるクーポン",
        value: applyVoucher.name
      };
    }
    if (broadcastDiscount !== null && broadcastDiscount !== void 0 && broadcastDiscount.result) {
      return {
        label: "適用される割引",
        value: "放送契約者割引"
      };
    }
  }, [applyVoucher]);

  // submitのコールバック
  const beforeSubmit = useCallback(data => {
    if (data.couponCode) {
      setUnppliedCouponError("クーポンコード入力されていますが適用されていません。\n適用ボタンを押すか、入力をクリアしてから購入するボタンを押してください。");
    } else {
      onSubmit(_objectSpread(_objectSpread({}, data), {
        applyVoucherCode
      }));
    }
  }, [onSubmit, applyVoucherCode]);

  // 前のページに戻る
  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    }
  }, [onBack]);

  // クーポン適用
  const applyCoupon = useCallback(() => {
    const couponCode = getValues("couponCode");
    estimateWithCouponQuery({
      variables: {
        voucherCode: couponCode,
        userVoucherId: broadcastDiscount === null || broadcastDiscount === void 0 ? void 0 : broadcastDiscount.user_voucher_id
      }
    });
  }, [broadcastDiscount]);

  // クーポンの適用キャンセル
  const handleCouponCancel = useCallback(() => {
    estimateWithCouponQuery({
      variables: {
        couponCode: null
      }
    });
  }, []);

  // クーポンコードのフォームが空になったら購入ボタン上のエラーメッセージをリセット
  useEffect(() => {
    if (unappliedCouponError && !watchCouponCode) {
      setUnppliedCouponError("");
    }
  }, [unappliedCouponError, watchCouponCode]);

  // ページ遷移したら購入ボタンを有効にする
  useEffect(() => {
    const resetSubmitted = () => {
      setSubmitted(false);
    };
    router.events.on("routeChangeComplete", resetSubmitted);
    return () => {
      router.events.off("routeChangeComplete", resetSubmitted);
    };
  }, []);
  if (loading || estimateLoading) return null;
  if (!(estimate !== null && estimate !== void 0 && estimate.product)) return null;

  // 放送契約割引がある
  // 視聴期間も表示する

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [couponLoading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: `${processStyles.content} ${styles.container}`,
        children: [/*#__PURE__*/_jsx("p", {
          className: processStyles.contentHeader,
          children: "\u4E0B\u8A18\u306E\u5185\u5BB9\u3067\u8CFC\u5165\u3057\u307E\u3059\u304B\uFF1F"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.container,
          children: /*#__PURE__*/_jsx("div", {
            className: `${styles.section} ${styles.column}`,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u5546\u54C1\u540D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: product.name
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u91D1\u984D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: /*#__PURE__*/_jsxs("span", {
                    className: styles.priceAmount,
                    children: [formatPrice(product.price), "\u5186", /*#__PURE__*/_jsx("span", {
                      children: "\uFF08\u7A0E\u8FBC\uFF09"
                    })]
                  })
                })]
              }), !(discountPrice == null) && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.label,
                    children: discountName.label
                  }), /*#__PURE__*/_jsxs("div", {
                    className: styles.value,
                    children: [discountName.value, applyVoucher && /*#__PURE__*/_jsx("a", {
                      className: `${styles.couponCancelLink} ${styles.inline}`,
                      onClick: handleCouponCancel,
                      children: "\u9069\u7528\u3092\u89E3\u9664\u3059\u308B"
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.label,
                    children: discountPrice.label
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.value,
                    children: /*#__PURE__*/_jsxs("span", {
                      className: styles.priceAmount,
                      children: [formatPrice(discountPrice.value), "\u5186", /*#__PURE__*/_jsx("span", {
                        children: "\uFF08\u7A0E\u8FBC\uFF09"
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u652F\u6255\u65B9\u6CD5"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [/*#__PURE__*/_jsx("div", {
                    children: PAYMENT_METHOD_NAMES[paymentMethod]
                  }), (paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_3DS || paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS) && /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx(PaymentIconImage, {
                      paymentMethodId: paymentMethod,
                      cardType: creditCardInfo.type,
                      className: paymentIconClassName
                    }), /*#__PURE__*/_jsx("span", {
                      children: creditCardInfo.number
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u6C7A\u6E08\u65E5"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: purchaseDate
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u8CA9\u58F2\u671F\u9593"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [salesStartAt, " \u301C ", salesEndAt]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: rightLabel
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: rightText
                })]
              })]
            })
          })
        })]
      })
    }), error && /*#__PURE__*/_jsx("div", {
      className: styles.creditCardError,
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        msg: error
      })
    }), /*#__PURE__*/_jsx(CouponCodeForm, {
      enable: !applyVoucherCode,
      register: register,
      apply: applyCoupon,
      error: estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : estimateWithCoupon.error
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.guideArea,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u89E3\u7D04\u306B\u3064\u3044\u3066", /*#__PURE__*/_jsx("br", {}), "\u5546\u54C1\u306E\u6027\u8CEA\u4E0A\u3001\u6C7A\u6E08\u5B8C\u4E86\u5F8C\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3084\u8FD4\u91D1\u7B49\u306B\u306F\u5FDC\u3058\u3089\u308C\u307E\u305B\u3093\u3002"]
      })
    }), /*#__PURE__*/_jsx("form", {
      onSubmit: handleSubmit(beforeSubmit),
      noValidate: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: formStyles.btnArea,
        children: [/*#__PURE__*/_jsx(Button, {
          type: "submit",
          fillColor: true,
          fontFixed: true,
          large: true,
          disabled: !isValid,
          loading: isSubmitting,
          children: "\u8CFC\u5165\u3059\u308B"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.backButton,
          children: /*#__PURE__*/_jsx("a", {
            onClick: handleBack,
            children: "\u524D\u306E\u753B\u9762\u3078\u623B\u308B"
          })
        })]
      })
    })]
  });
}